import * as z from "zod";

export const preferencesSchema = z.object({
  accommodation: z.string().optional(),
  food: z.array(z.string()).optional(),
  notes: z.array(z.string()).optional(),
});

export const guestSchema = z.object({
  firstName: z.string().nonempty(),
  lastName: z.string().nonempty(),
  phone: z.string().nonempty(),
  email: z.email(),
  photoId: z.string().nullish(),
  language: z.string().optional(),
  dateOfBirth: z.string().nonempty(),
  preferences: preferencesSchema.nullish(),
});

export type PreferencesData = z.infer<typeof preferencesSchema>;
export type GuestFormData = z.infer<typeof guestSchema>;
